import { FunctionComponent, useMemo } from 'react'
import {
  Action,
  createAction,
  ErrorTemplate
} from '@/modules/accredited-establishments/components/List'
import { useList } from '@/modules/accredited-establishments/hooks'
import { useMediaQuery } from '@/global/hooks'

const ApiErrorMessage: FunctionComponent = () => {
  const { isError, error, refetch } = useList()

  const isMobile = useMediaQuery({ maxWidth: 'mobile' })

  const title = useMemo(() => {
    if (error?.status === 403) {
      return 'Houve um erro com o seu Wifi'
    }

    return 'Algo deu errado ao carregar as informações'
  }, [error])

  const description = useMemo(() => {
    if (error?.status === 403) {
      return 'Por favor, tente em uma rede de celular (3G, 4G, 5G).'
    }

    return 'Tente novamente em instantes ou atualize a página.'
  }, [error])

  const actions = useMemo((): Action[] => {
    return [
      createAction({
        label: 'Tentar novamente',
        icon: 'icUpdate',
        onClick: () => refetch(),
        isMobile
      })
    ]
  }, [refetch, isMobile])

  return (
    <ErrorTemplate
      active={isError}
      title={title}
      description={description}
      actions={actions}
    />
  )
}

export { ApiErrorMessage }
